import Select from 'react-select';
import React from 'react';
import cfg from 'cfg';
import _ from 'lodash';
import * as rmd from 'material-ui';

class TournamentPickerMulti extends React.Component {
    static defaultProps = {
        sportId: 1
    };

    constructor(props, context) {
        super(props, context);
        let tournamentIds;
        try {
            tournamentIds = JSON.parse(props.tournamentIds);
        } catch (e) {
            tournamentIds = [];
        }

        this.state = {
            tournaments: [],
            tournamentIds
        };
    }

    componentDidMount() {
        this.loadTournaments();
    }

    loadTournaments() {
        let { sportId } = this.props;
        let { tournamentId, countryId } = this.state;

        return fetch(`${cfg.apis.ss2}/tournaments?sportId=${sportId}`)
            .then(response => response.json())
            .then(tournaments => this.setState({ tournaments: tournaments }))
            .catch(e => {
                console.error(e);
                this.setState({ tournaments: [] });
            });
    }

    handleTournamentChange = payload => {
        let tournamentIds = payload.map(t => t.value);
        this.setState({ tournamentIds }, () => {
            this.props.onChange({ tournamentIds: tournamentIds });
        });
    };

    renderOption(option) {
        return <rmd.MenuItem key={option.value} value={option.value} primaryText={option.text} />;
    }

    render() {
        let { tournaments, tournamentIds } = this.state;

        let tournamentsOptions = this.state.tournaments.map(t => ({ label: t.name, value: t.id }));

        return (
            <div className="wdp-tournament-multi-picker">
                <Select
                    value={tournamentIds}
                    multi
                    options={tournamentsOptions}
                    search
                    placeholder="Select leagues"
                    onChange={this.handleTournamentChange}
                />
            </div>
        );
    }
}

export default TournamentPickerMulti;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TournamentPickerMulti.js
 **/